import {Injectable} from '@angular/core';
import {environment} from "../../../../../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {WaTemplate} from "../../../../../template/wa-template-preview/wa-template.service";
import {SharedService} from "../../../../../../../core/services/store/shared-store/shared-storage.service";

@Injectable({
    providedIn: 'root'
})

export class SendTemplateService {

    private readonly baseUri: string = environment.controlBaseUrl;

    constructor(private http: HttpClient, private shardService: SharedService) {
    }

    WaBusinessAccounts: WaBusinessAccounts[];
    WaIntegrations: { [index: string]: WaIntegrations[] } = {};
    WaTemplates: { [index: string]: WaTemplate[] } = {};

    localEntity = {
        entityId: '',
        entityType:  ''
    }

    public get_accounts(): Observable<WaBusinessAccounts[]> {

        this.checkEntity();

        if (this.WaBusinessAccounts && this.WaBusinessAccounts.length > 0) {
            return of(this.WaBusinessAccounts)
        }

        return this.http.get<WaBusinessAccounts[]>(`${this.baseUri}/wa/${this.shardService.getEntityType()}/${this.shardService.getEntityId()}/business-accounts`).pipe(
            map((wabaAccount: WaBusinessAccounts[]) => {
                if (wabaAccount === null) {
                    return [WaBusinessAccountsError];
                }
                this.WaBusinessAccounts = wabaAccount;
                return wabaAccount;
            }),
            catchError((_) => {
                return of([WaBusinessAccountsError]);
            })
        )
    }

    public get_integrations(AccountId: string): Observable<WaIntegrations[]> {

        this.checkEntity();

        if (this.WaIntegrations[AccountId]) {
            return of(this.WaIntegrations[AccountId])
        }

        return this.http.get<WaIntegrations[]>(`${this.baseUri}/wa/${this.shardService.getEntityType()}/${this.shardService.getEntityId()}/business-accounts/${AccountId}/integrations`).pipe(
            map((waIntegration: WaIntegrations[]) => {
                if (waIntegration === null) {
                    return [];
                }
                this.WaIntegrations[AccountId] = waIntegration;
                return waIntegration;
            }),
            catchError((_) => {
                return of([]);
            })
        )
    }

    public get_templates(IntegrationId): Observable<WaTemplate[]> {

        this.checkEntity();

        if (this.WaTemplates[IntegrationId]) {
            return of(this.WaTemplates[IntegrationId])
        }

        return this.http.get<WaTemplate[]>(`${this.baseUri}/wa/${this.shardService.getEntityType()}/${this.shardService.getEntityId()}/integrations/${IntegrationId}/templates`).pipe(
            map((waTemplate: WaTemplate[]) => {
                if (waTemplate === null) {
                    return [];
                }
                this.WaTemplates[IntegrationId] = waTemplate;
                return waTemplate;
            }),
            catchError((_) => {
                return of([]);
            })
        )
    }

    private checkEntity() {
        if (this.shardService.getEntityType() !== this.localEntity.entityType || this.shardService.getEntityId() !== this.localEntity.entityId) {
            this.WaBusinessAccounts = []
            this.WaIntegrations = {};
            this.WaTemplates = {};
        }

        this.localEntity.entityId = this.shardService.getEntityId();
        this.localEntity.entityType = this.shardService.getEntityType()

    }
}

export interface WaBusinessAccounts {
    wabaName: string,
    id: string,
    status: string,
    templateNamespace: string,
    wabaId: string,
    accountId: string
}

export interface WaIntegrations {
    integrationId: string,
    active: string,
    env: string,
    integrationName: string,
    phoneNumber: string,
    whatsAppAccountId: string,
    whatsaAppAccountName: string,
    expiration: string
}

const WaBusinessAccountsError: WaBusinessAccounts = {
    wabaName: null,
    id: null,
    status: null,
    templateNamespace: null,
    wabaId: null,
    accountId: null
}

const WaIntegrationError: WaIntegrations = {
    integrationId: null,
    active: null,
    env: null,
    integrationName: null,
    phoneNumber: null,
    whatsAppAccountId: null,
    whatsaAppAccountName: null,
    expiration: null
}

const waTemplateError: WaTemplate = {
    templateContent: null,
    name: null,
    numOfParams: null,
    tag: null,
    preApproved: null,
    status: null,
    type: null,
    wabaName: null,
    template: null,
    whatsAppBusinessAccount: null,
    id: "_ERROR_"
}


